import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Typography } from "@mui/material";
import { ProdutoSelecionado } from "../Step02/DisplayIncluirNaoSugeridos/DialogAdicionar";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";

export default function DialogEncomenda({
    open,
    handleClose,
    selecionado,
    onSubmit
}: DialogEncomendaProps) {

    const [encomendas, setEncomendas] = useState(selecionado?.encomenda)

    const handleSubmitEncomenda = () => {
        if (!encomendas) return
        if (encomendas > (selecionado?.quantidade ?? 0)) {
            enqueueSnackbar("Encomenda não pode ser maior que a quantidade solicitada", { variant: "error" })
            return
        }
        onSubmit(encomendas)
        handleClose()
    }
    
    const handleCleanEncomenda = () => {
        onSubmit(null)
        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                Informar encomenda
            </DialogTitle>

            <DialogContent>
                <Alert severity="info" icon={false}>
                    <Typography variant="subtitle1">{selecionado?.nome}</Typography>
                </Alert>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle2">
                        Qtd. Solicitada: <b>{selecionado?.quantidade} {selecionado?.unidade_medida}</b>
                    </Typography>

                    <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={encomendas}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setEncomendas(Number(event.target.value))
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment
                                        position="end"
                                    >
                                        {selecionado?.unidade_medida}
                                    </InputAdornment>
                                )
                            }
                        }}
                        sx={{ maxWidth: 140 }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCleanEncomenda}>Limpar</Button>
                <Button
                    disabled={!encomendas}
                    variant="contained"
                    onClick={handleSubmitEncomenda}
                    autoFocus
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogEncomendaProps {
    open: boolean;
    handleClose: () => void;
    selecionado?: ProdutoSelecionado;
    onSubmit: (encomenda: number | null) => void;
}

